import { Link } from "react-router-dom";

const cards = [
  {
    image: "/assets/images/ready_to_wear.JPG",
    title: "Crafted Details",
    text: "Pin-tucks, tassels and hand-finished buttons on every piece.",
    href: "/shop?category=stitched",
  },
  {
    image: "/assets/images/crafted_detail.JPG",
    title: "Ready to Wear",
    text: "Effortless sets, stitched and ready for dinners and gatherings.",
    href: "/shop?category=ready-to-wear",
  },
  {
    image: "/assets/images/formal_wear.JPG",
    title: "Formal Wear",
    text: "Polished pieces made for evenings, festivities and formal occasions.",
    href: "/shop?category=formal-wear",
  },
];

const Services = () => {
  return (
    <>
      <div className="more">
        <Link className="btn" to="/shop">
          Explore more
        </Link>
      </div>
      <section className="sec">
        <h2>Why AYZEN</h2>
        <div className="detail">
          {cards.map((card) => (
            <Link className="dcard" to={card.href} key={card.title}>
              <div className="ph">
                <img alt="" src={card.image} />
              </div>
              <div className="t">
                <h3 className="serif">{card.title}</h3>
                <p>{card.text}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
};

export default Services;
